module.exports = __webpack_public_path__ + "img/fenxi.9b2bcc20.jpg";